import React, {useState} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Grid} from '@material-ui/core'
import Authentication from './containers/Authentication'
import {SettingsProvider} from './utils/Settings'
import Dashboard from './containers/Dashboard'
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles'
import AuthorizedRoute from './utils/AuthorizedRoute'
import PageTitle from './components/PageTitle/PageTitle'
import Loader from './components/Loader'
import Toast from './components/Toast/Toast'
import Layout from './myAccount/containers/Layout'
import {RecoilRoot} from 'recoil'

const Onboard = React.lazy(() => import('./containers/Onboard'))
// const MyAccount = React.lazy(() => import('./myAccount/containers/Layout'))

const theme = createMuiTheme({
    palette: {
        primary: {main: '#4194F2'}, // Purple and green play nicely together.
        secondary: {main: '#6ABC6A'}, // This is just green.A700 as hex.
    },
})

export const ToastContext = React.createContext()

const ToastComp = props => {
    const [toastInfo, setToastInfo] = useState({})
    return (
        <ToastContext.Provider value={{toastInfo, showToast: setToastInfo}}>
            <Toast {...toastInfo} />
            {props.children}
        </ToastContext.Provider>
    )
}

const App = () => {
    return (
        <MuiThemeProvider theme={theme}>
            <RecoilRoot>
                <SettingsProvider>
                    <Grid container className="fi-root-grid-main__wrapper">
                        <ToastComp>
                            <Grid item xs className="fi-root-grid__wrapper">
                                <Switch>
                                    <Route
                                        exact
                                        path="/dashboard"
                                        render={props => (
                                            <PageTitle {...props} component={Dashboard} />
                                        )}
                                    />
                                    <AuthorizedRoute checkParams path="/onboard">
                                        <React.Suspense fallback={<Loader type="page" />}>
                                            <Onboard />
                                        </React.Suspense>
                                    </AuthorizedRoute>
                                    <AuthorizedRoute exact path="/myaccount">
                                        <React.Suspense fallback={<Loader type="page" />}>
                                            <Layout />
                                        </React.Suspense>
                                    </AuthorizedRoute>
                                    <Route component={Authentication} />
                                </Switch>
                            </Grid>
                        </ToastComp>
                    </Grid>
                </SettingsProvider>
            </RecoilRoot>
        </MuiThemeProvider>
    )
}

export default App
